const bike_calculator = () => {

    jQuery("[name='cover-amount']").on('change', function(){

        var parent = jQuery(this).closest('.cycle-calculator')
        var yearly = jQuery(this).data('yearly')
        var monthly = jQuery(this).data('monthly')

        parent.find('.per-month').text('£'+monthly)
        parent.find('.per-year').text('£'+yearly)

    })
}

export default bike_calculator